const CONFIG_SECTION_LABELS = {
  hub: null,
  process: 'Processos',
  go: 'Go',
  users: 'Usuários',
  usersCustomers: 'Customers',
  company: 'Empresa',
  integrations: 'Integrações',
  painelControle: 'Painel de controle',
  equipe: 'Gestão de equipe',
  compatibilidade: 'Compatibilidade',
};

const CONFIG_SECTION_ROUTES = {
  process: '/configuracoes/processos',
  go: '/configuracoes/go',
  users: '/configuracoes/usuarios',
  usersCustomers: '/configuracoes/customers',
  company: '/configuracoes/empresa',
  integrations: '/configuracoes/integracoes',
  equipe: '/cadastros/equipe',
  compatibilidade: '/cadastros/compatibilidade-equipamentos',
};

const PROCESS_SUBMENU_LABELS = {
  'config-status-2': 'Configuração de status',
  'coluna-em-aberto': 'Configuração de colunas',
  'condicoes-intervencao': 'Condições de intervenção',
  'defeitos-verve': 'Defeitos',
  oficina: 'Oficina',
  'cadastros-marcas-subgrupos': 'Especialidade técnica',
  'notificacoes-email': 'Notificações por email',
};

const GO_SUBMENU_LABELS = {
  usuarios: 'Usuários',
  dispositivos: 'Dispositivos',
};

/**
 * Monta o caminho legível da tela atual em Configurações.
 * @param {{ section?: string, submenuId?: string|null, extraPath?: string|null }} params
 */
export function buildConfigOryaContextPath({ section = 'process', submenuId = null, extraPath = null } = {}) {
  const sec = section || 'hub';
  if (sec === 'hub') {
    const parts = ['Configurações'];
    if (extraPath) parts.push(String(extraPath).trim());
    return parts.join(' > ');
  }

  const isCadastros = sec === 'equipe' || sec === 'compatibilidade';
  const parts = isCadastros
    ? ['Cadastros', CONFIG_SECTION_LABELS[sec] || CONFIG_SECTION_LABELS.equipe]
    : ['Configurações'];

  if (!isCadastros) {
    const sectionLabel = CONFIG_SECTION_LABELS[sec];
    if (sectionLabel) parts.push(sectionLabel);

    if (sec === 'process' && submenuId) {
      const submenuLabel = PROCESS_SUBMENU_LABELS[submenuId];
      if (submenuLabel) parts.push(submenuLabel);
    }

    if (sec === 'go' && submenuId) {
      const submenuLabel = GO_SUBMENU_LABELS[submenuId];
      if (submenuLabel) parts.push(submenuLabel);
    }
  }

  if (extraPath) {
    parts.push(String(extraPath).trim());
  }

  return parts.join(' > ');
}

export function buildConfigOryaRoutePath({ section = 'process', submenuId = null } = {}) {
  const base = CONFIG_SECTION_ROUTES[section] || '/configuracoes';
  if ((section === 'process' || section === 'go') && submenuId) {
    return `${base}#${submenuId}`;
  }
  return base;
}

/**
 * Prefixo enviado à API (oculto na UI do chat).
 */
export function buildConfigOryaQuestionWithContext(userQuestion, contextPath) {
  const question = String(userQuestion || '').trim();
  const path = String(contextPath || '').trim();
  if (!path) return question;
  return `[Contexto da navegação: ${path}]\n\n${question}`;
}

export function getConfigOryaFirstName(displayName) {
  const s = String(displayName || '').trim();
  if (!s) return 'você';
  return s.split(/\s+/)[0];
}
